import createIcon from '../../createIcon';

/**
 * @component @name Input
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMy4wMTAwMUgzQzEuOSAzLjAxMDAxIDEgMy45MTAwMSAxIDUuMDEwMDFWOS4wMDAwMUgzVjQuOTkwMDFIMjFWMTkuMDJIM1YxNUgxVjE5LjAxQzEgMjAuMTEgMS45IDIwLjk5IDMgMjAuOTlIMjFDMjIuMSAyMC45OSAyMyAyMC4xMSAyMyAxOS4wMVY1LjAxMDAxQzIzIDMuOTAwMDEgMjIuMSAzLjAxMDAxIDIxIDMuMDEwMDFaTTExIDE2TDE1IDEyTDExIDguMDAwMDFWMTFIMVYxM0gxMVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Input = createIcon('Input', [
  [
    'path',
    {
      d: 'M21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM11 16L15 12L11 8.00001V11H1V13H11V16Z',
      key: '198fq4',
    },
  ],
]);

export default Input;
